import React from "react"

import { LANGUAGE } from "actions/constants"

export default {
    [LANGUAGE.EN]: [
        {
            Title: () => <>Chiang Mai Temple Tour</>,
            Date: () => <>10/27/2025</>,
            Time: () => <>12:00 pm pickup</>,
            Location: () => <>Vans to leave from Kaomai Lanna</>,
            locationLink:
                "https://maps.app.goo.gl/9MHyt8CSNGa1ozVe9",
            Address: () => (
                <>
                </>
            ),
            mapLink:
                "",
            Details: () => (
                <>
                    <p>
                        We're organizing an outing, for those interested, to some of the best temples outside of downtown Chiang Mia.  Vans will leave from Kaomai Lanna resort. We're planning on going to:
<ul>
  <li>Wat Phra That Doi Kham</li>
  <li>Wat Umong</li>
  <li>Wat Pha Lat</li>
  <li>Wat Phra That Doi Suthep</li>
</ul>
                        The trip will end at Laan Na Kitchen in time for the rehearsal dinner. 
                        <br />
                        Please note the dress code for visiting Thai temples: shoulders and knees must be covered for both men and women.  Also you may be asked to remove your shoes before entering some of the temples.
                         
                    </p>
                </>
            ),
        },
        {
            Title: () => <>Rehearsal Dinner</>,
            Date: () => <>10/27/2025</>,
            Time: () => <>6:00 pm</>,
            Location: () => <>Laan Na Kitchen (Inside of Melia Chiang Mai 
Hotel) </>,
            locationLink: "https://www.metrostaycation.com/2024/11/laan-na-kitchen-at-melia-chiang-mai.html",
            Address: () => (
                <>
                    <p>46, 48 Charoenprathet Road, Chang Khlan,</p>
                    <p> Chiang Mai, Thailand </p>
                </>
            ),
            mapLink:
                "https://maps.app.goo.gl/CgdBuEcY2Gota7ij9",
            Details: () => (
                <>
                    <p>
                        All our guests are invited to attend the rehearsal 
dinner the night before the wedding.  Casual attire. 
                        Check out the <a href="https://dam.melia.com/melia/file/yqbarGCvzY86fMq3K6An.pdf?response-content-disposition=attachment%3B%20filename%3D%22MEL_CHIANG_MAI_Laan+Na+Kitchen+menu.pdf%22"> menu</a>.
                    </p>
                </>
            ),
        },
        {
            Title: () => <>Chinese Tea Ceremony</>,
            Date: () => <>10/28/2025</>,
            Time: () => <>3:00 pm</>,
            Location: () => <>Kaomai Lanna</>,
            locationLink: "https://www.kaomailanna.com",
            Address: () => (
                <>
                    <p>1 Moo 6 Chiang Mai-Hod Rd.,</p>
                    <p>Ban Klang Sun Pa Tong</p>
                    <p>Ban Klang Sun Pa Tong</p>
                    <p>Chiang Mai</p>
                    <p>Tel. +66 5348 1201 , 086 428 7481</p>
                </>
            ),
            mapLink:
                "https://maps.app.goo.gl/exUd4bAQBYf9bVpRA",
            Details: () => (
                <>
                    <p>
                        The Tea Ceremony is a Chinese tradition where the bride and groom serve
                        tea to the parents before the wedding ceremony.  Before they can serve the 
                        tea, the groom needs to pass the test, which takes the form of a series of 
                        fun games and hazing.
                        {/*The ceremony, dinner and reception will take place at Kaomai 
                        Lanna - a boutique resort set in a big beautiful tropical garden.
                        Western and Thai food choices will be provided for 
dinner.  More details coming soon.*/}
                        {/*Its unique buildings are repurposed tobacco curing barns from a time
                        period when tobacco was the main industry of Chiang Mai.*/}
                    </p>
                </>
            ),
        },
        {
            Title: () => <>Cocktail Hour</>,
            Date: () => <>10/28/2025</>,
            Time: () => <>4:00 pm</>,
            Location: () => <>Kaomai Lanna</>,
            locationLink: "https://www.kaomailanna.com",
            Address: () => (
                <>
                    <p>1 Moo 6 Chiang Mai-Hod Rd.,</p>
                    <p>Ban Klang Sun Pa Tong</p>
                    <p>Ban Klang Sun Pa Tong</p>
                    <p>Chiang Mai</p>
                    <p>Tel. +66 5348 1201 , 086 428 7481</p>
                </>
            ),
            mapLink:
                "https://maps.app.goo.gl/exUd4bAQBYf9bVpRA",
            Details: () => (
                <>
                    <p>
                        Drinks and snacks will be provided near where the ceremony will take place starting an hour before the ceremony.  So come, have a drink, listen to some music, and get ready for the party.
                        {/*The ceremony, dinner and reception will take place at Kaomai 
                        Lanna - a boutique resort set in a big beautiful tropical garden.
                        Western and Thai food choices will be provided for 
dinner.  More details coming soon.*/}
                        {/*Its unique buildings are repurposed tobacco curing barns from a time
                        period when tobacco was the main industry of Chiang Mai.*/}
                    </p>
                </>
            ),
        },
        {
            Title: () => <>Ceremony</>,
            Date: () => <>10/28/2025</>,
            Time: () => <>5:08 pm</>,
            Location: () => <>Kaomai Lanna</>,
            locationLink: "https://www.kaomailanna.com",
            Address: () => (
                <>
                    <p>1 Moo 6 Chiang Mai-Hod Rd.,</p>
                    <p>Ban Klang Sun Pa Tong</p>
                    <p>Ban Klang Sun Pa Tong</p>
                    <p>Chiang Mai</p>
                    <p>Tel. +66 5348 1201 , 086 428 7481</p>
                </>
            ),
            mapLink:
                "https://maps.app.goo.gl/exUd4bAQBYf9bVpRA",
            Details: () => (
                <>
                    <p>
                        We will celebrate our vows in front of friends in family.
                        Hope to see you there!
                        {/*The ceremony, dinner and reception will take place at Kaomai 
                        Lanna - a boutique resort set in a big beautiful tropical garden.
                        Western and Thai food choices will be provided for 
dinner.  More details coming soon.*/}
                        {/*Its unique buildings are repurposed tobacco curing barns from a time
                        period when tobacco was the main industry of Chiang Mai.*/}
                    </p>
                </>
            ),
        },
        {
            Title: () => <>Reception</>,
            Date: () => <>10/28/2025</>,
            Time: () => <>After the ceremony</>,
            Location: () => <>Kaomai Lanna</>,
            locationLink: "https://www.kaomailanna.com",
            Address: () => (
                <>
                    <p>1 Moo 6 Chiang Mai-Hod Rd.,</p>
                    <p>Ban Klang Sun Pa Tong</p>
                    <p>Ban Klang Sun Pa Tong</p>
                    <p>Chiang Mai</p>
                    <p>Tel. +66 5348 1201 , 086 428 7481</p>
                </>
            ),
            mapLink:
                "https://maps.app.goo.gl/exUd4bAQBYf9bVpRA",
            Details: () => (
                <>
                    <p>
                        We'll have dinner and dancing.  See the RSVP page to choose your main course.
                        {/*Its unique buildings are repurposed tobacco curing barns from a time
                        period when tobacco was the main industry of Chiang Mai.*/}
                    </p>
                </>
            ),
        },
    ],
    [LANGUAGE.ZH]: [
        {
            Title: () => <>清迈寺庙之旅</>,
            Date: () => <>2025年10月27日</>,
            Time: () => <>中午开始</>,
            Location: () => <>车辆将从 Kaomai Lanna 或市中心指定地点（待定）出发。</>,
            locationLink: "",
            Address: () => (
                <>
              
                </>
            ),
            mapLink:
                "",
            Details: () => (
                <>
                    <p>
我们正在为那些感兴趣的人组织一次外出活动，前往清迈市中心外一些最棒的寺庙。如果您在回复表格上告知我们您的住宿地点，车辆将从 Kaomai Lanna 度假村或您的市中心酒店出发。我们计划前往：

<ul>
<li>金佛山寺（Wat Phra That Doi Kham）</li>
<li>悟孟寺（Wat Umong）</li>
<li>帕拉寺（Wat Pha Lat）</li>
<li>素贴山寺（Wat Phra That Doi Suthep）</li>
</ul>
此次行程将在排练晚宴开始前，在 Laan Na Kitchen 结束。
<br />
请注意参观泰国寺庙的着装要求：男士和女士的肩膀及膝盖都必须遮盖。此外，进入一些寺庙前您可能需要脱鞋。
                        
                    </p>
                </>
            ),
        },
        {
            Title: () => <>欢迎晚宴</>,
            Date: () => <>2025年10月27日</>,
            Time: () => <> 晚上六点</>,
            Location: () => <>Laan Na Kitchen (清迈美利亚酒店内）</>,
            locationLink: "https://www.metrostaycation.com/2024/11/laan-na-kitchen-at-melia-chiang-mai.html",
            Address: () => (
                <>
                    <p>Carretera de la Sénia, Km. 2</p>
                    <p>43550 Ulldecona, Catalunya</p>
                </>
            ),
            mapLink: "https://surl.amap.com/orXENz1eaGw",
            Details: () => (
                <>
                    <p>
                        
所有受邀嘉宾均可参加婚礼前一晚的彩排晚宴。着装休闲。查看<a href="https://dam.melia.com/melia/file/yqbarGCvzY86fMq3K6An.pdf?response-content-disposition=attachment%3B%20filename%3D%22MEL_CHIANG_MAI_Laan+Na+Kitchen+menu.pdf%22">菜单</a>。
                    </p>
                </>
            ),
        },
        {
            Title: () => <>中式敬茶</>,
            Date: () => <>10/28/2025</>,
            Time: () => <>下午三点</>,
            Location: () => <>Kaomai Lanna</>,
            locationLink: "https://www.kaomailanna.com",
            Address: () => (
                <>
                    <p>1 Moo 6 Chiang Mai-Hod Rd.,</p>
                    <p>Ban Klang Sun Pa Tong</p>
                    <p>Ban Klang Sun Pa Tong</p>
                    <p>Chiang Mai</p>
                    <p>Tel. +66 5348 1201 , 086 428 7481</p>
                </>
            ),
            mapLink:
                "https://maps.app.goo.gl/exUd4bAQBYf9bVpRA",
            Details: () => (
                <>
                    <p>
                        新人向双方父母敬茶
                        {/*The ceremony, dinner and reception will take place at Kaomai 
                        Lanna - a boutique resort set in a big beautiful tropical garden.
                        Western and Thai food choices will be provided for 
dinner.  More details coming soon.*/}
                        {/*Its unique buildings are repurposed tobacco curing barns from a time
                        period when tobacco was the main industry of Chiang Mai.*/}
                    </p>
                </>
            ),
        },
        {
            Title: () => <>鸡尾酒时间</>,
            Date: () => <>10/28/2025</>,
            Time: () => <>下午四点</>,
            Location: () => <>Kaomai Lanna</>,
            locationLink: "https://www.kaomailanna.com",
            Address: () => (
                <>
                    <p>1 Moo 6 Chiang Mai-Hod Rd.,</p>
                    <p>Ban Klang Sun Pa Tong</p>
                    <p>Ban Klang Sun Pa Tong</p>
                    <p>Chiang Mai</p>
                    <p>Tel. +66 5348 1201 , 086 428 7481</p>
                </>
            ),
            mapLink:
                "https://maps.app.goo.gl/exUd4bAQBYf9bVpRA",
            Details: () => (
                <>
                    <p>
                    婚礼仪式开始前一个小时，我们会在场地附近准备好饮品和点心。大家可以早点来，喝点东西，听听音乐，为接下来的派对热热身。
                        {/*The ceremony, dinner and reception will take place at Kaomai 
                        Lanna - a boutique resort set in a big beautiful tropical garden.
                        Western and Thai food choices will be provided for 
dinner.  More details coming soon.*/}
                        {/*Its unique buildings are repurposed tobacco curing barns from a time
                        period when tobacco was the main industry of Chiang Mai.*/}
                    </p>
                </>
            ),
        },
        {
            Title: () => <>婚礼</>,
            Date: () => <>2025年10月28日</>,
            Time: () => <> 晚上五点零八分</>,
            Location: () => <>高迈兰纳度假村</>,
            locationLink: "https://www.kaomailanna.com",
            Address: () => (
                <>
                    <p>1 Moo 6 Chiang Mai-Hod Rd.,</p>
                    <p>Ban Klang Sun Pa Tong</p>
                    <p>Ban Klang Sun Pa Tong</p>
                    <p>Chiang Mai</p>
                    <p>Tel. +66 5348 1201 , 086 428 7481</p>
                </>
            ),
            mapLink:
                "https://maps.app.goo.gl/exUd4bAQBYf9bVpRA",
            Details: () => (
                <>
                    <p>
                        我们将与家人朋友共同庆祝我们的誓约。

期待在那里与您相见！
                        {/*Its unique buildings are repurposed tobacco curing barns from a time
                        period when tobacco was the main industry of Chiang Mai.*/}
                    </p>
                </>
            ),
        },
        {
            Title: () => <>婚宴</>,
            Date: () => <>10/28/2025</>,
            Time: () => <>在婚礼仪式后</>,
            Location: () => <>高迈兰纳度假村</>,
            locationLink: "https://www.kaomailanna.com",
            Address: () => (
                <>
                    <p>1 Moo 6 Chiang Mai-Hod Rd.,</p>
                    <p>Ban Klang Sun Pa Tong</p>
                    <p>Ban Klang Sun Pa Tong</p>
                    <p>Chiang Mai</p>
                    <p>Tel. +66 5348 1201 , 086 428 7481</p>
                </>
            ),
            mapLink:
                "https://maps.app.goo.gl/exUd4bAQBYf9bVpRA",
            Details: () => (
                <>
                    <p>
                        我们将共进晚餐并跳舞。请在 RSVP 页面选择您的主菜。
                        {/*Its unique buildings are repurposed tobacco curing barns from a time
                        period when tobacco was the main industry of Chiang Mai.*/}
                    </p>
                </>
            ),
        },
    ],
}
